import React, { useEffect, useState, useContext } from "react";
import QuoteRequestDetails from "./QuoteRequestDetails";
import SalesRepQuoteRequestForm from "./SalesRepQuoteRequestForm";
import { useLocation, useNavigate } from "react-router-dom";
import useHttp from "../../hooks/use-http";
import QuoteSubmitConfirmation from "../Confirmation/QuoteSubmitConfirmation";
import { Form, Link } from "react-router-dom";
import Button from "../UI/Button";
import CustomerDetails from "./CustomerDetails";
import AddressDetails from "./AddressDetails";
import AuthContext from "../../store/auth-context";
import AppContext from "../../store/app-context";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';

import styles from "./AdditionalInformation.module.css";

const AdditionalInformation = (props) => {
  const authCtx = useContext(AuthContext);
  const appCtx = useContext(AppContext);

  let label_updateMsg = 'Your cart updates have been saved and applied to this Quote Request.';
  let label_rfqForm = 'Quote Request Form';
  let label_requiredFields = 'Indicates required fields.';
  let label_submitRFQ = 'Submit Quote Request';
  let label_buttonBack = 'Back';

  if(appCtx && appCtx.bioradResources){
    label_updateMsg = appCtx.bioradResources.Quote_Updated_Message ? appCtx.bioradResources.Quote_Updated_Message : 'Your cart updates have been saved and applied to this Quote Request.';
    label_rfqForm = appCtx.bioradResources.Rfq_Form ? appCtx.bioradResources.Rfq_Form : 'Quote Request Form';
    label_requiredFields = appCtx.bioradResources.Indicates_Required_Field ? appCtx.bioradResources.Indicates_Required_Field : 'Indicates required fields.';
    label_submitRFQ = appCtx.bioradResources.Submit_Quote_Request ? appCtx.bioradResources.Submit_Quote_Request : 'Submit Quote Request';
    label_buttonBack = appCtx.bioradResources.Back_To_Quote ? appCtx.bioradResources.Back_To_Quote : 'Back to Quote Cart';
  }

  const navigate = useNavigate();
  const location = useLocation();
  let webReference = location?.state?.quote?.webReference;
  const itemChanges = location?.state?.itemChanges;
  let acctInfo = location?.state?.acctInfo;
  let quote = location?.state?.quote;

  sessionStorage.removeItem("submittedWebRef");

  if(webReference){
    sessionStorage.setItem("webReference",webReference);
  }
  if(acctInfo){
    sessionStorage.setItem("acctInfo", JSON.stringify(acctInfo));
  }
  if(quote){
    sessionStorage.setItem("quote", JSON.stringify(quote));
  }

  if(!webReference && sessionStorage.getItem("webReference")){
    webReference = sessionStorage.getItem("webReference");
  }
  if(!acctInfo && sessionStorage.getItem("acctInfo")){
    acctInfo =  JSON.parse(sessionStorage.getItem("acctInfo"));
  }
  if(!quote && sessionStorage.getItem("quote")){
    quote =  JSON.parse(sessionStorage.getItem("quote"));
  }

  const isSalesRep = quote.userType === "SalesRep" ? true : false;
  const isPunchOutSession = authCtx?.isLoggedIn && authCtx?.sessionUser?.b2bUser;
  const isPartiallyReg = !acctInfo?.soldTo && !isPunchOutSession ? true : false;
  console.log('isPartiallyReg: ' + isPartiallyReg);

  const [isLoading, setIsLoading] = useState(false);
  const {
    isLoadingGetQuote,
    errorGetQuote,
    sendRequest: updateLineItems,
  } = useHttp();
  const { isLoadingRFQ, errorSubmitRFQ, sendRequest: submitRFQ } = useHttp();
  const { sendRequest: getFreshRfq } = useHttp();
  const [errorMsg, setErrorMsg] = useState("Error fetching data...");
  const [isAPIError, setIsAPIError] = useState(false);
  const [isRfqUpdate, setIsRfqUpdate] = useState(false);
  const [isRFQSubmittedSuccessfully, setIsRFQSubmittedSuccessfully] =
    useState(false);
  const [webReferences, setWebReferences] = useState({
    LSG: props.webReference,
  });

  const [invalidFieldList, setInvalidFieldList] = useState({});

  const [isInvalidComments, setIsInvalidComments] = useState(false);
  const invalidCharRegex = /[^\p{L}\p{N}\p{P}\p{Z}\p{Sc}\n]|[<>%"]/u;

  let itemIds = "";
  let qtys = "";
  if(itemChanges){
    itemChanges.map((item) => {
      itemIds += item.itemId + ",";
      qtys += item.qty + ",";
    });
  }

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    if (!webReference) {
      navigate("/");
    }
    if (itemIds !== "" && qtys !== "") {
      setIsLoading(true);
      const setQuoteData = (quoteData) => {
        setIsLoading(false);
        setIsRfqUpdate(true);
      };
      updateLineItems(
        {
          url:
            "/quoteservices/rfqs/items/" +
            webReference +
            "?itemIds=" +
            itemIds +
            "&qtys=" +
            qtys,
          method: "post",
          headers: { "Content-type": "application/text" },
        },
        setQuoteData,
        "json"
      ).catch((error) => {
        if (error && error.message) {
          setErrorMsg(error.message);
        }
        setIsAPIError(true);
        setIsLoading(false);
      });
      //setIsLoading(false);
    }
  }, []);

  const rfqFormSubmitHandler = async (event) => {
    event.preventDefault();

    const hasLineItems = quote && quote.quoteLineEntityList && quote.quoteLineEntityList.length > 0;

    const isFormValid = (event) => {
      let isValidForm = true;
      let invalidFields = {};

      for (let i = 0; i < event.target.length; i++) {
        let fieldName = event.target.elements[i].getAttribute("name");
        if (
          (fieldName === "custFName" ||
            fieldName === "custLName" ||
            fieldName === "company" ||
            fieldName === "custEmail" ||
            fieldName === "custSoldTo" ||
            fieldName === "custShipTo" ||
            fieldName === "add1" ||
            fieldName === "city" ||
            fieldName === "state" ||
            fieldName === "zip" ||
            fieldName === "dateQuoteNeeded" ||
            fieldName === "ppPlan" ||
            fieldName === "phone") &&
          event.target.elements[i].value === ""
        ) {
          invalidFields[fieldName] = true;
        }

        if (
          fieldName === "comments" &&
          !hasLineItems &&
          event.target.elements[i].value === ""
        ) {
          invalidFields[fieldName] = true;
        }

        if (
          fieldName === "comments" &&
          invalidCharRegex.test(event.target.elements[i].value)
        ) {
          setIsInvalidComments(true);
          isValidForm = false;
        }
      }

      if (Object.keys(invalidFields).length > 0) {
        setInvalidFieldList(invalidFields);
        isValidForm = false;
      }
      return isValidForm;
    };

    if (!isFormValid(event)) {
      return;
    }

    const rfqFormData = (event) => {
      let formData = {};
      for (let i = 0; i < event.target.length; i++) {
        if (event.target.elements[i].getAttribute("type") === "checkbox") {
          formData[event.target.elements[i].getAttribute("name")] =
            event.target.elements[i].checked;
        } else {
          formData[event.target.elements[i].getAttribute("name")] =
            event.target.elements[i].value;
        }
      }
      if(!isSalesRep && !isPartiallyReg && acctInfo && acctInfo.shipAddress){
        formData['company'] = acctInfo.shipAddress.firstName ? acctInfo.shipAddress.firstName : '';
        formData['add1'] = acctInfo.shipAddress.addressLine1 ? acctInfo.shipAddress.addressLine1 : '';
        formData['city'] = acctInfo.shipAddress.city ? acctInfo.shipAddress.city : '';
        formData['state'] = acctInfo.shipAddress.state ? acctInfo.shipAddress.state : '';
        formData['zip'] = acctInfo.shipAddress.zipCode ? acctInfo.shipAddress.zipCode : '';
        formData['country'] = acctInfo.shipAddress.countryCode ? acctInfo.shipAddress.countryCode : '';
      }
      return formData;
    };

    setIsLoading(true);

    const handleSubmitReponse = (responseDoc) => {
      if (responseDoc.isSuccess) {
        setIsRFQSubmittedSuccessfully(true);
        responseDoc.webReference && setWebReferences(responseDoc.webReference);
      } else {
        setIsAPIError(true);
        setErrorMsg(responseDoc?.message ?? "Error submitting quote.");
      }
      setIsLoading(false);
    };

    const accountParams = acctInfo ? '?' + new URLSearchParams(acctInfo).toString().replaceAll('%27',' ') : "";
    const formData = rfqFormData(event);

    try {
      let freshCsrfToken = null;
      await getFreshRfq(
        { url: "/quoteservices/rfqs/rfq/" + webReference },
        (quoteData) => {
          freshCsrfToken = quoteData && quoteData.csrfToken;
        },
        "json"
      );

      await submitRFQ(
        {
          url: "/quoteservices/rfqs/rfq/" + webReference + "/submit" + accountParams,
          method: "POST",
          body: { ...formData, csrfToken: freshCsrfToken },
        },
        handleSubmitReponse,
        "json"
      );
    } catch (error) {
      if (error && error.message) {
        setErrorMsg(error.message);
      }
      setIsAPIError(true);
      setIsLoading(false);
    }
  };

  if (isRFQSubmittedSuccessfully) {
    //return <QuoteSubmitConfirmation webRef={webReferences} />;
    navigate('/confirmation',{state:{submittedWebRef:webReferences, quote:quote}})
  }

  const backToQuoteLink = '/'+webReference;

  // Adobe Analytics: userView and pageView
  SetAnalyticsData();

  return (
    <div className={styles.rfqquoteForm}>
      {props.isRfqUpdate && (
        <div>
          <p>
            <span>{label_updateMsg}</span>
          </p>
        </div>
      )}
      <div className={styles.quoteemail__header}>
        <h2>{label_rfqForm}</h2>
        <p>{label_requiredFields}</p>
      </div>
      {isAPIError && <p className={styles.errorMsg}>{errorMsg}</p>}
      <Form method="post" onSubmit={rfqFormSubmitHandler}>
        {isSalesRep && <CustomerDetails invalidFieldList={invalidFieldList} />}
        {isPartiallyReg && (
          <AddressDetails invalidFieldList={invalidFieldList} />
        )}
        <QuoteRequestDetails invalidFieldList={invalidFieldList} quote={quote} />
        <Button type="submit">{label_submitRFQ}</Button>
        <div className={styles.quote_links}>
            <Link to={backToQuoteLink}>{label_buttonBack}</Link>
        </div>
      </Form>
      {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
    </div>
  );
};

export default AdditionalInformation;
